import { createStyles } from "@material-ui/core";

var styles = function styles(theme) {
  return createStyles({
    wrapper: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(255,255,255,0.7)'
    },
    progressContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%'
    },
    progress: {
      // margin: theme.spacing(2),
      color: theme.palette.primary.main
    }
  });
};

export default styles;